import request, { generateNotyMessage } from 'utils/request'
import { actions as notyActions } from 'layouts/ErrorBox'
import { browserHistory } from 'utils/navigation'
import { sendingActions } from 'store/sender'
import STRINGS from 'utils/strings'
import { REDIRECT_DELAY } from 'utils/constants'
import { getStudyVersionID } from '../../../../../../../../../utils/studyConfigUtils'
import { logSentryEvent } from '../../../../../../../../../utils/sentry'

const uploadStudyAsset = ({ formData, studyID, loadingKey = 'mediaUpload' }) => {
  const success = payload => {
    const { filename } = payload
    return {
      filename,
    }
  }
  return dispatch => {
    return dispatch(
      request({
        method: 'POST',
        url: `/control/studies/${studyID}/assets/upload`,
        contentType: 'multipart/form-data',
        body: formData,
        hasLoader: true,
        loadingKey,
        success,
      }),
    )
  }
}

const uploadTrainingMaterial = ({ trainingMaterial, studyID }) => {
  return (dispatch, getState) => {
    const studyVersionID = getStudyVersionID(getState()?.location)
    const hasStudyPromotion = !!getState()?.study?.currentStudy?.config?.study_promotion
    const success = () => {
      dispatch(sendingActions.stopSender())
      setTimeout(() => {
        dispatch(sendingActions.resetSender())
        browserHistory.push(`/studies/${studyID}/${studyVersionID}/training`)
      }, REDIRECT_DELAY)
    }
    const fail = (res, content) => {
      logSentryEvent({
        message: 'Upload training material failed',
        level: 'error',
        tags: {
          module: 'training.upload',
          'http.status': res?.status,
        },
        contexts: {
          training: {
            studyID,
            hasStudyPromotion,
            studyVersionID,
            responseMessage: content?.message,
          },
        },
      })
      dispatch(notyActions.showError({ text: generateNotyMessage(content.message, false) }))
      dispatch(sendingActions.resetSender())
    }
    dispatch(sendingActions.startSender())
    return dispatch(
      request({
        method: 'POST',
        url: `/control/studies/${studyID}/training`,
        body: JSON.stringify({ ...trainingMaterial, study_version_id: hasStudyPromotion ? studyVersionID : undefined }),
        hasLoader: true,
        success,
        successMessage: STRINGS.trainingUploadSuccess,
        fail,
      }),
    )
  }
}

const actions = {
  uploadStudyAsset,
  uploadTrainingMaterial,
}

export default actions
